export const getStyles = (props) => {
    const { palette } = props.theme;
    return {
        editor: {
            padding: '4px',
            border: `1px solid ${palette.neutralSecondaryAlt}`,
            resize: 'both',
            overflow: 'auto',
            maxWidth: '100%',
            display: 'block',
            boxSizing: 'border-box',
            minHeight: '50px',
        },
        editorDisabled: {
            // remove all the html colors in the editor
            '*': {
                color: 'unset!important',
                backgroundColor: 'unset!important',
            },
            backgroundColor: palette.neutralLighter,
            color: palette.neutralTertiary,
        },
        commandBarContainer: {
            paddingTop: '2px',
        },
    };
};
